import React, { useState, useContext, useRef } from "react";
import { useHistory } from "react-router-dom";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import { TextField } from "@material-ui/core";
import "../../styles/components/Editor.scss";
import "../../styles/pages/Banners/BannerManager.scss";

import "../../styles/components/EditorModal.scss";
import ErrComponentToRender from "../../Uitls/apiErrorHandling";
import DropDownWithLabelTemplate from "../DropDownWithLabelTemplate.js";
import {
  getNewBrandsAndcampaigns,
  cloneBanner,
  basedOnBanner,
  getCognitoSession,
  getCognitoIndentityCredentials,
} from "../../services/apis";
import DropDownWithSearchTemplate from "../DropDownWithSearchTemplate";
import { toast } from "react-toastify";
import { nameValidation } from "../../Uitls/Util.js";

//Denovo related imports
//MArket Data returnlated imports and varaihle declaration
import { isoCountryTableName, awsRegion } from "../../Uitls/Util";
import ValueContext from "../../ContextAPi/appContext";
import Button from "@material-ui/core/Button";
var dynamo = require("dynamodb");

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  dialog: {
    width: "362px",
    height: "426px",
  },
}));
export default function BasedOnModalNew(props) {
  const history = useHistory();
  const { t } = useTranslation();
  const { recentlyViewedData } = props;
  const appData = useContext(ValueContext);
  const [brandsAndCampaigns, setBrandsAndCampaigns] = useState([]);
  const [marketDataSource, setMarketDataSource] = useState([]);
  const [selectedMarket, setSelectedMarket] = useState(undefined);
  const [helperText, setHelperText] = useState("");
  const [errorMsg, setErrorMsg] = useState(false);

  const [genericInfo, setGenericInfo] = useState({
    brand: "",
    campaign: "",
    market: "",
    bannerNameInput: "",
    templateNameInput: "",
    //tagName: "",
  });
  const dropdownWidth = useRef(null);

  const handleFormReset = () => {
    setGenericInfo({
      brand: "",
      campaign: "",
      market: "",
      bannerNameInput: "",
      templateNameInput: "",
      //tagName: "",
    });
    setSelectedMarket("");
  };

  React.useEffect(() => {
    setGenericInfo({
      ...genericInfo,
      campaign: "",
    });
  }, [appData?.genericInfo.brand]);

  React.useEffect(() => {
    fetchBrandsAndCampaigns();
    fetchMarketData();
    getCampaignListToPopulate(
      appData?.genericInfo?.brand || recentlyViewedData?.brand
    );

    appData?.genericInfo?.brand &&
      appData?.genericInfo?.brand !== "— Not Brand Specific —" &&
      setGenericInfo({
        ...genericInfo,
        campaign: appData?.genericInfo?.campaign,
        brand: appData.genericInfo.brand,
      });
  }, []);
  //Fetch Brands and campaigns
  const fetchBrandsAndCampaigns = () => {
    getNewBrandsAndcampaigns((response, err, errCode) => {
      if (err) {
        const errCoponent = ErrComponentToRender(errCode);
        toast.error(errCoponent);
      } else {
        //parse and save
        const data = response.data;
        if (data && data.length > 0) {
          setBrandsAndCampaigns(data);
        }
      }
    });
  };

  //Returns Campaign list to populate in Drop down
  const getCampaignListToPopulate = (Brand) => {
    if (
      Brand &&
      brandsAndCampaigns.length > 0 &&
      Brand !== "— Not Brand Specific —"
    ) {
      const campaigns = brandsAndCampaigns.filter((object) => {
        return object.brandName === Brand;
      })[0]?.campaigns;
      if (campaigns && campaigns.length > 0) {
        const desiredList = campaigns.map((campaign) => {
          return campaign["campaignName"];
        });
        if (desiredList && desiredList.length > 0) {
          return desiredList;
        }
      }
    }
    return [];
  };

  function validateForm() {
    return (
      genericInfo.bannerNameInput?.length > 2 &&
      genericInfo?.brand !== "— Not Brand Specific —" &&
      genericInfo?.brand?.length > 0 &&
      genericInfo?.campaign?.length > 0
      //appData?.genericInfo?.tagName?.length > 0
    );
  }
  const handleChangeInfoDataBlur = (e) => {
    if (e.target.value.length < 3 && e.target.value.length !== 0) {
      toast.error(
        <div className="notificationText">
          {t("bannerManager.bnrNameMinErr")}
        </div>
      );
    }
  };
  const handleChangeInfoData = (e) => {
    const { name, value } = e.target;
    setGenericInfo({ ...genericInfo, [name]: value });
    if (name === "templateNameInput") {
      if (e.target.value.length > 255) {
        toast.error(
          <div className="notificationText">
            {t("bannerManager.bnrNameErr")}
          </div>
        );
      }
    }
    if (brandsAndCampaigns) {
      brandsAndCampaigns.map((brand) => {
        if (brand.brandName === value) {
          appData.setBrandId(brand.brandId);
        }
        brand.campaigns.map((campaign) => {
          if (campaign.campaignName === value)
            appData.setCampaignId(campaign.campaignId);
        });
      });
    }
    let obj = { ...appData?.genericInfo, [name]: value };
    appData.updateGenericInfo(obj);
    setErrorMsg(false);
    setHelperText("");
  };

  // const fetchMarketData = () => {
  //   updateDynamicDBConfig(dynamo)
  //   var params = {
  //     TableName: isoCountryTableName
  //   };
  //   getDyanamoDBInstance(dynamo).scan(params, (error, data) => {
  //     if (data) {
  //       let marketData = data.Items
  //       if (marketData && marketData.length > 0) {
  //         marketData = [...marketData].map((market) => {
  //           let object = {
  //             code: market.countryCode['S'],
  //             shortName: market.ShortName['S'],
  //             name: market.Name['S']
  //           }
  //           object['displayName'] = `${object.code} - ${object.name}`
  //           return object
  //         })
  //         if (marketData && marketData.length > 0) {
  //           const sortCountryCode=marketData.sort(function(a,b){
  //             if(a.code.toLowerCase() < b.code.toLowerCase()) {
  //               return -1;
  //             }
  //             if (a.code.toLowerCase() > b.code.toLowerCase()) {
  //               return 1;
  //             }
  //             return 0;
  //           })
  //           setMarketDataSource(sortCountryCode)
  //         }
  //       }
  //     }
  //   })
  // }

  const fetchMarketData = () => {
    getCognitoSession((session) => {
      if (session) {
        getCognitoIndentityCredentials(session, dynamo.AWS, (credentials) => {
          if (!credentials) {
            return;
          }
          var params = {
            TableName: isoCountryTableName,
          };
          var docClient = new dynamo.AWS.DynamoDB.DocumentClient({
            region: awsRegion,
          });
          docClient.scan(params, function (err, data) {
            if (data) {
              let marketData = data.Items;
              if (marketData && marketData.length > 0) {
                marketData = [...marketData].map((market) => {
                  let object = {
                    code: market.countryCode,
                    shortName: market.ShortName,
                    name: market.Name,
                  };
                  object["displayName"] = `${object.code} - ${object.name}`;
                  return object;
                });
                if (marketData && marketData.length > 0) {
                  marketData = [...marketData].sort((marketOne, marketTwo) => {
                    if (marketOne.name < marketTwo.name) {
                      return -1;
                    }
                    if (marketOne.name > marketTwo.name) {
                      return 1;
                    }
                    return 0;
                  });
                  setMarketDataSource(marketData);
                }
              }
            }
          });
        });
      }
    });
  };

  const handleMarketChange = (market) => {
    if (market) {
      setSelectedMarket(market);
      setGenericInfo({ ...genericInfo, market: market.name });
      appData.setMarketCode(market.code);
      appData.updateGenericInfo({
        ...appData?.genericInfo,
        market: market.name,
      });
    }
  };

  const getSelectedMarket = () => {
    if (!selectedMarket && appData && appData?.genericInfo?.market) {
      const countryName = appData?.genericInfo?.market;
      const countryCode = appData.marketCode;
      const displayName = `${countryCode} - ${countryName}`;
      return { name: countryName, code: countryCode, displayName: displayName };
    }
    return selectedMarket;
  };

  const categoriesErr = (value) => {
    toast.error(value, { position: toast.POSITION.TOP_RIGHT });
  };
  const cloneBannerData = () => {
    if (!nameValidation(genericInfo.bannerNameInput, "Banner")) return;

    var formData = new FormData();
    formData.append("brandName", genericInfo?.brand ? genericInfo?.brand : "");
    formData.append("name", genericInfo?.bannerNameInput);
    formData.append("campaign", genericInfo?.campaign);
    formData.append("brandId", appData?.brandId);
    formData.append("campaignId", appData?.campaignId);
    formData.append("marketName", appData?.genericInfo?.market);
    formData.append("marketCode", appData?.marketCode);

    // formData.append("tagName", appData?.genericInfo?.tagName);

    basedOnBanner(
      appData.assetInfo.assetId,
      formData,
      (response, err, errorCode, errorMessage) => {
        if (err) {
          const errCoponent = ErrComponentToRender(errorCode);
          if (err.response.data?.errorCode === "ERR_CS_ASSETNAME_EXISTS") {
            toast.error(
              <div className="notificationText">
                {t("apiErrors.errBannerExist")}
              </div>
            );
          } else {
            toast.error(
              <div className="notificationText">{t("apiErrors.err500")}</div>
            );
          }
        } else {
          const obj = {
            brand: response.data.brandName,
            campaign: response.data.campaign,
            market: response.data.marketName,
            templateNameInput: response.data.assetName,
            // tagName: response.data.tagName,
          };
          appData.updateGenericInfo({ ...appData?.genericInfo, ...obj });
          setSelectedMarket(obj.market);
          appData.setAssetInfo({
            assetId: "",
            assetName: obj.templateNameInput,
          });

          localStorage.removeItem("assetId");
          localStorage.setItem("assetId", response.data.id);
          history.push(`/banner-editor/${response?.data?.id}`);
        }
      }
    );
  };
  // const handleTagChange = (e) => {
  //   const { name, value } = e.target;
  //   let obj = appData?.genericInfo;
  //   obj["tagName"] = value;
  //   // appData.updateGenericInfo(obj);
  //   appData.updateGenericInfo({ ...appData?.genericInfo, ...obj });
  // };

  const handleBrandChange = (e) => {
    const { name, value } = e.target;

    if (name === "templateNameInput") {
      if (e.target.value.length > 250) {
        toast.error(
          <div className="notificationText">
            {t("bannerManager.tempNameErr")}
          </div>,
          { autoClose: 1200, hideProgressBar: false }
        );
      }
    }
    setGenericInfo({ ...genericInfo, [name]: value });
    if (brandsAndCampaigns) {
      brandsAndCampaigns &&
        brandsAndCampaigns.map((brand) => {
          if (brand.brandName === value) {
            appData.setBrandId(brand.brandId);
          }
          brand.campaigns &&
            brand.campaigns.map((campaign) => {
              if (campaign.campaignName === value)
                appData.setCampaignId(campaign.campaignId);
            });
        });
    }
  };

  return (
    <>
      <Dialog
        disableBackdropClick
        open={props.showBasedOn}
        onClose={() => props.setShowBasedOn(false)}
        className="basedOnModalnew "
        aria-labelledby="form-dialog-title"
        overlaystyle={{ backgroundColor: "transparent" }}
      >
        <DialogTitle id="form-dialog-title">
          <div className="baseOnModalHeading">
            {t("bannerManager.basedOnTitle")}
          </div>
        </DialogTitle>
        <DialogContent>
          <div className="row newbannerDetails ">
            <TextField
              variant="standard"
              label={t("Banner Name")}
              name="bannerNameInput"
              className="bannerNameTextfield templateNameTextfield"
              style={{ marginBottom: "8px " }}
              fullWidth={true}
              value={genericInfo.bannerNameInput}
              onChange={handleChangeInfoData}
              onBlur={handleChangeInfoDataBlur}
              autoComplete="off"
              helperText={helperText}
              error={errorMsg}
            ></TextField>
            {appData?.genericInfo?.brand === "— Not Brand Specific —" ? (
              <div className="newInputFieldTemp brandNm" ref={dropdownWidth}>
                <DropDownWithLabelTemplate
                  options={{
                    value:
                      genericInfo?.brand === "— Not Brand Specific —"
                        ? ""
                        : genericInfo?.brand,
                    name: "brand",
                    label: t("bannerManager.brandName"),
                    items: props.getBrandsToPopulate("basedOnNew"),
                    handleChange: handleBrandChange,
                  }}
                  menuWidth={
                    dropdownWidth.current?.getBoundingClientRect().width *
                      0.95 || undefined
                  }
                />
              </div>
            ) : (
              <TextField
                variant="standard"
                value={genericInfo?.brand}
                name="brand"
                label={t("bannerManager.brandName")}
                className="bannerNameTextfield  templateNameTextfield "
                fullWidth={true}
                onChange={handleChangeInfoData}
                autoComplete="off"
                disabled="true"
              ></TextField>
            )}
            {getSelectedMarket() && marketDataSource.length > 0 && (
              <DropDownWithSearchTemplate
                options={{
                  value: getSelectedMarket(),
                  name: "market",
                  label: t("bannerManager.market"),
                  items: marketDataSource,
                  handleChange: handleMarketChange,
                }}
                className="custonScrollBar"
              />
            )}

            <div className="newInputFieldTemp brandNm" ref={dropdownWidth}>
              <DropDownWithLabelTemplate
                options={{
                  value:
                    genericInfo?.brand === "— Not Brand Specific —"
                      ? ""
                      : genericInfo.campaign || "",
                  name: "campaign",
                  label: t("bannerManager.campaign"),
                  items: getCampaignListToPopulate(genericInfo?.brand),
                  handleChange: handleChangeInfoData,
                }}
                menuWidth={
                  dropdownWidth.current?.getBoundingClientRect().width * 0.95 ||
                  undefined
                }
              />
            </div>
          </div>
        </DialogContent>
        <DialogActions className="modalActions">
          <Button
            onClick={() => {
              props.setShowBasedOn(false);
              handleFormReset();
            }}
            color="primary"
            className="cancelBtn cancelbtnBasedon"
          >
            {t("bannerManager.cancel")}
          </Button>
          <Button
            onClick={cloneBannerData}
            type="submit"
            className="btn btn-primary"
            disabled={!validateForm()}
            autoFocus
            style={{ position: "relative", left: "-11px" }}
          >
            {t("bannerManager.proceed")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
